import React, { useContext } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { DashboardContext } from "../contexts/DashboardContext";

export default function TopSkillsChart() {
  const { skillsData } = useContext(DashboardContext);

  return (
    <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col h-[340px]">
      <h3 className="text-sm font-bold text-slate-800 mb-4">Top Skills</h3>
      <div className="flex-1 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={skillsData}
            layout="vertical"
            margin={{ top: 0, right: 30, left: 0, bottom: 0 }}
            barSize={12}
          >
            <XAxis type="number" hide />
            <YAxis
              dataKey="name"
              type="category"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 11, fill: "#475569" }}
              width={85}
            />
            <Tooltip cursor={{ fill: "transparent" }} />
            <Bar dataKey="value" fill="#3b82f6" radius={[0, 4, 4, 0]}>
              <LabelList
                dataKey="value"
                position="right"
                style={{ fontSize: 11, fill: "#0f172a", fontWeight: 600 }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------------------------
